import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Prism-Admin';

  allClients: any = [];
  allSites: any = [];

  constructor() {}
}
